import { Button, message, Upload as UploadAntd, Image } from "antd";
import React, { useState, useEffect } from "react";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import apiPath from "../constants/apiPath";
import { ShowToast, Severty } from "../helper/toast";
import { getFileExtension } from "../helper/functions";
import lang from "../helper/langHelper";

// Uploads now go through the backend (POST /admin/media/upload), which
// holds the real AWS credentials server-side and never exposes them. This
// used to upload straight to S3 from the browser with a hardcoded access
// key + secret baked into this file — visible to anyone via view-source on
// the deployed site, no login required. See MediaUploadController.ts.
const SingleImageUpload1 = ({
  fileType,
  value,
  imageType,
  btnName,
  onChange,
  size = 500,
  width = 600,
  height = 600,
  isDimension = false,
  ...props
}) => {
  const [file, setFile] = useState([]);



  const checkImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = document.createElement("img");

      img.onload = () => {
        if (img.width === width && img.height === height) {
          resolve();
        } else {
          reject(
            `Please upload an image with dimensions (${width}X${height}). uploaded image is ${img.width} X ${img.height}`,
          );
        }
      };

      img.src = URL.createObjectURL(file);
    });
  };

  const beforeUpload = async (file) => {
    try {
      const ext = file.name?.split(".").pop()?.toLowerCase();
      const EXTENSION_WHITELIST = ["one", "onepkg","url"];

      const isMimeAllowed = file.type && fileType.includes(file.type);
      const isExtAllowed  = EXTENSION_WHITELIST.includes(ext);

      if (!isMimeAllowed && !isExtAllowed) {
        ShowToast("File format is not correct", Severty.ERROR);
        return false;
      }
      const fileSizeMB = file.size / 1024 / 1024;
      if (fileSizeMB > size) {
        ShowToast(`File must be ${size} MB or smaller.`, Severty.ERROR);
        return false;
      }
      // If check dimension
      // isDimension && (await checkImageDimensions(file));
      return true;
    } catch (err) {
      ShowToast(err, Severty.ERROR);
      return false;
    }
  };

  const onRemove = () => {
    setFile([]);
    if (onChange) {
      onChange("");
    }
  };

  useEffect(() => {
    console.log(value, "value")
    if (value) {
      setFile([value])
    } else {
      setFile([])
    };
  }, [value]);

  const uploadFileToS3 = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await axios.post(`${apiPath.baseURL}admin/media/upload`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return { Location: res.data?.data?.url };
  };

  const handleImgChange = async (event) => {
    const { file } = event;
    setFile([file]);
    try {
      const data = await uploadFileToS3(file);
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: 'done',
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
      if (onChange) {
        onChange([fileData]);
      }
      //   setFile([fileData]);
      console.log(data);
    } catch (err) {
      console.error(err);
    }
  };
  console.log(file, "file1111")
  return (
    <UploadAntd
      listType="picture"
      maxCount={1}
      beforeUpload={beforeUpload}
      customRequest={handleImgChange}
      onRemove={onRemove}
      fileList={file}
      {...props}
    >
      {file && file.length > 0 && file !== "" ? null : (
        <Button icon={<UploadOutlined />}>
          {" "}
          {btnName ? `${lang("Upload")} ${btnName}` : ""}
        </Button>
      )}


    </UploadAntd>
  );
};

export default SingleImageUpload1;
